import { loadTheme } from '@uifabric/styling';
import store from '../store/store';
import { getFluentThemeValues } from 'owa-fluent-fabric';

export default function updateFabricTheme() {
    const { fluentPalette, fluentEffects } = getFluentThemeValues();
    const { palette, fonts, isInverted } = store();

    loadTheme({
        ...fluentEffects,
        fonts,
        isInverted,
        palette: {
            ...fluentPalette,
            ...palette,
        },
    });
}
